import { CopyrightOutlined } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import { useViewport } from "@bindeleddet/core/hooks";
import colors from "frontend/src/constants/colors";
import { ThemeToggle } from "components/ThemeToggle/ThemeToggle";
import { MutedFooterLink } from "./FooterBottomBar.styled";

import HallOfFame from "../HallOfFame/HallOfFame";
import { FOOTER_BREAKPOINT } from "../constants";

const { Paragraph } = Typography;

const FooterBottomBar = () => {
  const { width } = useViewport();

  return (
    <Row
      gutter={{
        xs: 8,
        sm: 16,
        md: 24,
        lg: 32,
      }}
      style={{ width: "100%", paddingLeft: "5%", paddingRight: "2%" }}
    >
      <Col span={width < FOOTER_BREAKPOINT ? 24 : 10} style={{ color: "grey" }}>
        <MutedFooterLink to="/privacy-policy/">Personvern</MutedFooterLink>
        <span> | </span>
        <MutedFooterLink to="/user-terms/">Brukevilkår</MutedFooterLink>
        <span> | </span>
        <HallOfFame />
      </Col>
      <Col
        span={width < FOOTER_BREAKPOINT ? 24 : 4}
        style={{
          justifyContent: width < FOOTER_BREAKPOINT ? "left" : "center",
          display: "flex",
          paddingBottom: "10px",
          position: "relative",
          bottom: width < FOOTER_BREAKPOINT ? "-2px" : "3px",
        }}
      >
        <ThemeToggle />
      </Col>
      <Col span={width < FOOTER_BREAKPOINT ? 24 : 10} style={width < FOOTER_BREAKPOINT ? {} : { textAlign: "right" }}>
        <Paragraph style={{ color: colors.textGray, paddingRight: "0.37em" }}>
          {new Date().getFullYear()} <CopyrightOutlined /> Bindeleddet NTNU. All rights reserved.
        </Paragraph>
      </Col>
    </Row>
  );
};

export default FooterBottomBar;
